import { FC, JSX, useMemo } from "react";
import { EllipsisTooltip } from "@app/shared/EllipsisTooltip";
import { MedicaidProgramPayers } from "@app/overviews/market-expansion-dashboard/shared/MedicaidCountyPrograms";

interface MedicaidPayerListProps {
  programs: MedicaidProgramPayers[];
}

const MedicaidPayerList: FC<MedicaidPayerListProps> = ({ programs }: MedicaidPayerListProps): JSX.Element => {
  const payerNames = useMemo(
    () => Array.from(new Set(programs.flatMap(p => p.payers))).sort(),
    [programs]
  );

  if (!payerNames.length) {
    return <></>;
  }

  return (
    <div>
      <div className="medicaid-payer-list__header">Payers</div>
      <div className="county-summary-popup__separator" />
      <ul className="medicaid-payer-list" data-testid="medicaid-payer-list">
        {payerNames.map((payerName) => (
          <li key={payerName} className="medicaid-payer-list__item" data-testid={`medicaid-payer-list__payer-${payerName}`}>
            <EllipsisTooltip text={payerName} width="100%" position="top" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MedicaidPayerList;
